<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16m8M0P/images/cover.jpg?1731429746832" alt="This image is the cover for the book Little Big Number"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Little Big Number
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The story of GDP and why we need a better measurement of growth</b><br/><br/>In one lifetime, GDP, or Gross Domestic Product, has ballooned from a narrow economic tool into a global article of faith. As <i>The Little Big Number</i> demonstrates, this spells trouble. While economies and cultures measure their performance by it, GDP only measures output. It ignores central facts such as quality, costs, or purpose. Sustainability and quality of life are overlooked. Losses don't count. The world can no longer afford GDP rule—GDP ignores real development. Dirk Philipsen demonstrates how the history of GDP reveals unique opportunities to fashion smarter goals and measures. <i>The Little Big Number</i> explores a possible roadmap for a future that advances quality of life rather than indiscriminate growth.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dirk Philipsen
      </h2>
      
      <p class="authorDescription body article"><B>Dirk Philipsen</B> is a German- and American-trained professor of economic history at the Sanford School of Public Policy and a senior fellow at the Kenan Institute for Ethics, both at Duke University.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Princeton University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0398c695